var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import classNames from "classnames";
import { defineMessages, injectIntl } from "react-intl";
import { FormControl } from "react-bootstrap";
// import leftArrowIcon from "../../../../../assets/img/games/leftArrowIcon.png";
// import filterIcon from "../../../../../assets/img/games/filterIcon.png";
// import resetIcon from "../../../../../assets/img/games/resetIcon.png";
import filterIcon from "../../../../assets/img/games/filter.svg";
import { FilterConflictToast, GameFilterSection } from "../styles";
import GamesFilterModal from "./GamesFilterModal";
import { cancelFiltering, handleSelectFilterOption, hideFilterConflict, setIsTopGames, showFilterConflict, showGamesFilterModal, } from "../../../../actions/games/creators";
var messages = defineMessages({
    search: {
        id: "games.search",
        defaultMessage: "Поиск",
    },
    popular_games: {
        id: "games.popular_games",
        defaultMessage: "Популярные игры",
    },
    filterConflict: {
        id: "games.filter_conflict",
        defaultMessage: "Можно выбрать только один фильтр: провайдер или тип",
    },
});
var FILTER_CONFLICT_AUTOHIDE_MS = 4000;
var GamesFilter = /** @class */ (function (_super) {
    __extends(GamesFilter, _super);
    function GamesFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { inputValue: _this.props.inputValue || "" };
        _this.getBack = function () {
            var _a = _this.props, isInLobbyGames = _a.isInLobbyGames, goToLobbyGames = _a.goToLobbyGames, history = _a.history;
            if (isInLobbyGames)
                history.push("/");
            else
                goToLobbyGames();
        };
        _this.handleShowModal = function () { return _this.props.showGamesFilterModalAction(true); };
        _this.handleCloseModal = function () {
            _this.props.showGamesFilterModalAction(false);
            _this.props.hideFilterConflictAction();
        };
        _this.handleReset = function () {
            var onGamesRoot = _this.props.location && _this.props.location.pathname === "/games";
            _this.props.cancelFilteringAction();
            _this.props.clearSearchField();
            _this.props.setIsTopGamesAction(false);
            if (onGamesRoot) {
                _this.props.goToLobbyGames();
            }
            else {
                _this.props.history.push("/games");
            }
        };
        _this.onHandleSelectChange = function (option, fieldName) {
            _this.props.handleSelectFilterOptionAction(option, fieldName);
        };
        _this.handleInputChange = function (e) {
            _this.setState({ inputValue: e.target.value });
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.handleSearch();
        };
        _this.handleSearch = function () {
            var query = _this.state.inputValue.trim();
            if (!query.length) {
                return;
            }
            ;
            _this.props.cancelFilteringAction();
            _this.props.history.push("/games/".concat(encodeURIComponent(query)));
        };
        _this.handleClickProvider = function (provider) {
            var _a = _this.props, selectedProviders = _a.selectedProviders, selectedTypes = _a.selectedTypes;
            var selected = selectedProviders.has(provider.Id);
            if (selected) {
                _this.handleReset();
                return;
            }
            var hadTypeSelected = selectedTypes && selectedTypes.size > 0;
            if (hadTypeSelected) {
                _this.props.showFilterConflictAction();
            }
            _this.props.history.push("/games/providers/".concat(encodeURIComponent(provider.Name)));
        };
        return _this;
    }
    GamesFilter.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.inputValue !== this.props.inputValue) {
            this.setState({ inputValue: this.props.inputValue || "" });
        }
        if (this.props.showModal && !prevProps.showModal && this.conflictHideTimer) {
            clearTimeout(this.conflictHideTimer);
            this.conflictHideTimer = null;
        }
        if (this.props.filterConflict && !prevProps.filterConflict && !this.props.showModal) {
            if (this.conflictHideTimer)
                clearTimeout(this.conflictHideTimer);
            this.conflictHideTimer = setTimeout(function () {
                _this.props.hideFilterConflictAction();
                _this.conflictHideTimer = null;
            }, FILTER_CONFLICT_AUTOHIDE_MS);
        }
    };
    GamesFilter.prototype.componentWillUnmount = function () {
        if (this.conflictHideTimer) {
            clearTimeout(this.conflictHideTimer);
            this.conflictHideTimer = null;
        }
    };
    GamesFilter.prototype.render = function () {
        var _this = this;
        var _a = this.props, intl = _a.intl, darkTheme = _a.darkTheme, providers = _a.providers, selectedProviders = _a.selectedProviders, showModal = _a.showModal, filterConflict = _a.filterConflict;
        var gameQuery = this.props.match.params.gameQuery;
        var showCloseIcon = Boolean(gameQuery && String(gameQuery).trim().length);
        var providersLimited = (providers || []).slice(0, 14);
        var showConflictToast = filterConflict && !showModal;
        return (_jsxs(GameFilterSection, __assign({ style: {
                backgroundColor: darkTheme && "#585858",
                color: darkTheme && "#fff",
                borderBottom: darkTheme && "1px solid #4a4a4a",
            } }, { children: [_jsxs("div", __assign({ className: "search" }, { children: [_jsx("form", __assign({ onSubmit: this.handleSubmit, style: { width: "100%" } }, { children: _jsx(FormControl, { type: "text", placeholder: this.props.isTop ? intl.formatMessage(messages.popular_games) : intl.formatMessage(messages.search), value: this.state.inputValue, onChange: this.handleInputChange, 
                                // className={darkTheme && "search-input-dark"}
                                className: classNames("search__input", {
                                    "search__input--dark": darkTheme,
                                }), inputMode: "search" }) })), showCloseIcon ? (_jsx("img", { className: "search__icon search__icon--close", src: "/assets/icons/close-dark.svg", alt: "", onClick: this.handleReset }, "close")) : (_jsx("img", { className: "search__icon", src: "/assets/icons/search.svg", alt: "", onClick: this.handleSearch }, "search"))] })), _jsxs("div", __assign({ className: "search__providers" }, { children: [_jsx("div", __assign({ className: "providers-list" }, { children: providersLimited.map(function (provider) {
                                var selected = selectedProviders.has(provider.Id);
                                return (_jsx("div", __assign({ className: classNames("provider", { active: selected }), onClick: function () { return _this.handleClickProvider(provider); } }, { children: provider.Name }), provider.Id));
                            }) })), _jsx("div", __assign({ className: "filter", onClick: this.handleShowModal }, { children: _jsx("img", { src: filterIcon, alt: "filterIcon", style: { filter: !darkTheme && "invert(0.8)" } }) }))] })), showModal && (_jsx(GamesFilterModal, { handleCloseModal: this.handleCloseModal, searchValue: this.props.inputValue, goToSearchedGames: this.props.goToSearchedGames, goToLobbyGames: this.props.goToLobbyGames })), showConflictToast && (_jsx(FilterConflictToast, __assign({ role: "alert", "aria-live": "polite" }, { children: intl.formatMessage(messages.filterConflict) })))] })));
    };
    return GamesFilter;
}(React.Component));
export default connect(function (state) { return ({
    user: state.auth.user,
    langId: state.application.get("languageId"),
    darkTheme: state.application.get("darkTheme"),
    showModal: state.games.gamesFilter.showModal,
    selectedProviders: state.games.gamesFilter.selectedProviders,
    selectedTypes: state.games.gamesFilter.selectedTypes,
    providers: state.games.gamesFilter.providers,
    types: state.games.gamesFilter.types,
    filterConflict: state.games.gamesFilter.filterConflict,
    limit: state.games.games.data.Limit,
    offset: state.games.games.data.Offset,
    isTop: state.games.games.isTop,
}); }, {
    showGamesFilterModalAction: showGamesFilterModal,
    handleSelectFilterOptionAction: handleSelectFilterOption,
    showFilterConflictAction: showFilterConflict,
    hideFilterConflictAction: hideFilterConflict,
    cancelFilteringAction: cancelFiltering,
    setIsTopGamesAction: setIsTopGames,
})(injectIntl(withRouter(GamesFilter)));



// WEBPACK FOOTER //
// ./src/components/games/components/GamesFilter/GamesFilter.jsx